import { render, staticRenderFns } from "./QuestionnaireResultDownload.vue?vue&type=template&id=5b537e22&"
import script from "./QuestionnaireResultDownload.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireResultDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports